import type { EscopoPadraoDialogProps } from "./types-escopo-padrao-dialog";
import { useEscopoPadraoDialog } from "./use-escopo-padrao-dialog";
import { EscopoPadraoDialogView } from "./view-escopo-padrao-dialog";

export function EscopoPadraoDialog(props: EscopoPadraoDialogProps) {
  const vm = useEscopoPadraoDialog(props);

  return <EscopoPadraoDialogView {...vm} />;
}

export type * from "./types-escopo-padrao-dialog";
